"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTemplateSize = getTemplateSize;
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const Template_1 = require("../../models/Template");
const getTemplateSurface_1 = require("./getTemplateSurface");
/**
 * Gets size off the template. It's not as simple as template.size,
 * because we're moving to a sizes array instead of 1 default size.
 *
 * @param template
 * @param printableGroupType We can have a different size per printable group type
 * @param interiorPageCount For book covers, your cover size changes based on page count
 */
function getTemplateSize(_ref) {
  let {
    template,
    printableGroupType,
    interiorPageCount
  } = _ref;
  if ((0, Template_1.isTemplateOriginal)(template)) {
    return (0, lodash_clonedeep_1.default)(template.size);
  } else if ((0, Template_1.isTemplate2024)(template)) {
    const surface = (0, getTemplateSurface_1.getTemplateSurface)({
      template,
      printableGroupType,
      interiorPageCount
    });
    const size = template.sizes.find(size => size.id === surface.sizeId);
    if (!size) {
      const message = 'Unable to find size';
      console.error(message, {
        printableGroupType,
        surface
      });
      throw new Error(message);
    }
    return (0, lodash_clonedeep_1.default)(size);
  }
  const message = 'Unable to get size from unsupported template schema version';
  throw new Error(message);
}